import { render, staticRenderFns } from "./Yida.vue?vue&type=template&id=1dc54056&scoped=true&"
import script from "./Yida.vue?vue&type=script&lang=js&"
export * from "./Yida.vue?vue&type=script&lang=js&"
import style0 from "./Yida.vue?vue&type=style&index=0&id=1dc54056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc54056",
  null
  
)

export default component.exports